import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CheckCircleOutlinedIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 18 18" htmlColor={Color.Headings} {...props}>
      <path d="M9 .506A8.486 8.486 0 0 0 .506 9c0 4.697 3.797 8.522 8.494 8.522 4.697 0 8.522-3.825 8.522-8.522S13.697.506 9 .506Zm0 15.75c-3.994 0-7.228-3.262-7.228-7.256A7.226 7.226 0 0 1 9 1.772c3.994 0 7.256 3.262 7.256 7.256 0 3.966-3.262 7.228-7.256 7.228Z" />
      <path d="M11.419 6.384 8.072 9.647l-1.519-1.49c-.253-.254-.647-.226-.9 0-.253.252-.225.646 0 .9l1.8 1.743a.872.872 0 0 0 .619.253c.225 0 .45-.084.619-.253l3.628-3.487a.628.628 0 0 0 0-.9.655.655 0 0 0-.9-.029Z" />
    </MuiSvgIcon>
  );
}
export default CheckCircleOutlinedIcon;
